export default {
  CYBER_ATTESTATION: {
    licensingEntity: 'publicSector',
    action: '/cybersecurity',
    actionWord: 'Confirm',
  },
  TDLR_RENEWAL: {
    licensingEntity: 'tdlr',
    action: '/tdlrlr',
    actionWord: 'Renew',
  },
};
